const wsk = {
  page404: {
    title: "Valószínűleg eltévedt",
    message: "Esetleg eltévedt?",
    action_btn: "Vissza az elejére"
  },
  address: {
    title: "Address",
    type: {
      personal: "Magánszemély",
      company: "Vállalkozás"
    },
    organisation: {
      label: "Szervezet"
    },
    name: {
      first_name: "Keresztnév",
      last_name: "Vezetéknév",
      label: "Név"
    },
    contact_person: {
      first_name: "Keresztnév",
      last_name: "Vezetéknév",
      label: "Kapcsolattartó személy"
    },
    street: {
      label: "Utca és házszám",
      address1: "Cím 1",
      address2: "Cím 2"
    },
    city: {
      label: "Település"
    },
    postal_code: {
      label: "Irányítószám"
    },
    country_code: {
      label: "Ország"
    },
    company_data: {
      title: "Cég adatai"
    },
    company_id: {
      label: "Cégjegyzék szám"
    },
    tax_id: {
      label: "Adószám"
    },
    vat_id: {
      label: "Közösségi adószám"
    }
  },
  empty_state: {
    title: "Nothing to show here..."
  },
  profile: {
    emails: {
      label: "E-mail címek (vesszővel elkülönítve)"
    },
    email: {
      label: "E-mail cím"
    },
    phone: {
      label: "Telefonszám",
      short: "Phone"
    }
  },
  validation: {
    country_required: "Először meg kell adnia az országot",
    company_id: {
      not_valid: "Érvénytelen cégjegyzékszám, kérjük, adjon meg másikat"
    },
    tax_id: {
      not_valid: "Érvénytelen adószám, kérjük, adjon meg másikat"
    },
    vat_id: {
      not_valid: "Érvénytelen közösségi adószám, kérjük, adjon meg másikat"
    }
  },
  general: {
    back: "Vissza",
    cancel: "Visszavonás",
    close: "Bezárás",
    remove: "Eltávolít",
    optional: "opcionális",
    period: {
      months_one: "{count} hónap",
      years_one: "{count} év",
      months_few: "{count} hónap",
      years_few: "{count} év",
      months_other: "{count} hónap",
      years_other: "{count} év",
      explicit: "Időszak",
      short: {
        months: "{ period, plural, one {hónap} other {# hónap} }",
        years_one: "év",
        years_few: "{count} év",
        years_other: "{count} év"
      },
      next: {
        months_one: "következő hónap",
        years_one: "következő év",
        months_few: "következő {count}  hónap",
        years_few: "következő {count} év",
        months_other: "következő {count}  hónap",
        years_other: "következő {count} év",
        short: {
          months_one: "következő hónap",
          years_one: "következő év",
          months_few: "következő {count}  hónap",
          years_few: "következő {count}  év",
          months_other: "következő {count}  hónap",
          years_other: "következő {count}  év"
        }
      },
      per: {
        months_one: "hónap",
        years_one: "Évekre",
        months_few: "{count}  hónapra",
        years_few: "{count}  évre",
        months_other: "{count}  hónapra",
        years_other: "{count}  évre",
        short: {
          months_one: "/hó",
          years_one: "/év",
          months_few: "/{count} hónap",
          years_few: "/{count} évre",
          months_other: "/{count} hónap",
          years_other: "/{count} évre"
        }
      }
    },
    or: "vagy",
    recommended: "ajánlott",
    settings: "Beállítások",
    edit: "Szerkesztés",
    save: "Mentés",
    save_changes: "módosítások mentése",
    reset_form: "űrlap visszaállítása",
    not_available: "nem elérhető",
    unknown_error: "Ismeretlen hiba",
    unknown_error_id: "Ismeretlen hiba ({id})",
    something_went_wrong: "Sajnáljuk, de ez egy nem várt eredmény, valami rosszul ment",
    link: "hivatkozás",
    buy: "Kosárba"
  },
  capslock_hint: {
    line1: "A Caps Lock",
    line2: "be van kapcsolva"
  },
  ws_password_input: {
    expose_password: "Jelszó megjelenítése"
  },
  ws_array_input: {
    incorrect_email: "Érvénytelen e-mail cím(ek).",
    incorrect_web: "Érvénytelen webcím(ek).",
    some_filtered: "Egyes eredmények érvénytelenek."
  },
  ws_places_input: {
    no_results: "A hely nem található, kérjük próbálja először kevésbé pontosan",
    start_typing: "Kezdje el beírni a címet a javaslatokhoz"
  },
  ws_uploader: {
    validation: {
      file_type: "A fájl típusa nem megfelelő",
      file_size: "A fájl mérete meghaladja a limitet {limit}"
    },
    status: {
      label: "Státusz",
      value: {
        uploaded: "feltöltve",
        uploading: "feltöltés",
        failed: "Sikertelen",
        idle: "idle"
      }
    },
    action: {
      title: "Számlák feltöltése",
      text1: "Fogd és vidd vagy",
      link: "fájl kiválasztása",
      text2: ".",
      abort_tooltip: "Feltöltés megszakítása"
    },
    supported_file_types: "Elfogadott fájltípusok:",
    remove_btn: "Eltávolít"
  },
  ws_table: {
    filter: {
      fulltext_title: "Teljes szöveges keresés",
      data_title: "Adat keresés",
      clear_filters: "Minden szűrő törlése",
      from: "From",
      to: "to"
    },
    label: {
      bulk_actions: "Tömeges műveletek",
      cancel_selection: "Kiválasztás visszavonása",
      item_selected: "kiválasztott elemek",
      selected: "Kiválasztva",
      filterby: "Szűrési feltételek",
      records_per_page: "Rekordok oldalanként:",
      select_all: "Mindet kiválaszt"
    }
  },
  ws_password_strength: {
    rule1: "minimum 8 karakter",
    rule2: "kis- és nagybetű",
    rule3: "legalább egy szám",
    rule4: "legalább egy speciális karakter"
  },
  ws_password_confirmation_input: {
    passwords_do_not_match: "A jelszavak nem egyeznek!"
  },
  ws_two_factor_authentication_input: {
    on_cooldown_one: "A kódot újraküldheted {{count}} másodperc múlva.",
    on_cooldown_few: "A kódot újraküldheted {{count}} másodperc múlva.",
    on_cooldown_other: "A kódot újraküldheted {{count}} másodperc múlva.",
    resend_code: "Kód újraküldése",
    code_being_sent: "2FA kód küldése folyamatban...",
    code_sent_successfully: "2FA kód sikeresen kiküldve",
    error_sending_code: "A 2FA kód kiküldése közben hiba lépett fel",
    invalid_code_pasted: "A bemásolt 2FA kód érvénytelen. Kérjük írd be az érvényes 2FA kódot."
  },
  generate_random: "Jelszó generálás",
  copy: {
    copy: "Másolás",
    copied: "Másolva",
    saved_in_clipboard: "Mentve a vágólapra"
  },
  out_modal: {
    title: "Sajnáljuk, a böngészője<br>nem naprakész",
    text: "Kérlek, frissítse azt a legújabb verzióra, vagy próbáljon meg egy másik böngészőt telepíteni.",
    delimiter_text: "Tudunk segíteni"
  },
  buttons: {
    ok_thanks: "Rendben, köszönöm!"
  },
  payment_cards: {
    ending_with: "Ending with",
    active: "Active",
    issued_by: "This card was issued by {issuer}."
  },
  ws_sub_items_price_summary: {
    current_price: "Service price (the current billing period)",
    due_now: "Due now",
    next_period_subtraction_warning: "* The price will be deducted from the next billing period",
    next_price: "Service price (the next billing period)"
  },
  dialog_footer: {
    cannot_submit_empty_form: "It is not possible to submit an empty form."
  },
  price_badge: {
    including_vat: "(including VAT)",
    excluding_vat: "(without VAT)"
  },
  cart_item: {
    notices: {
      business_mail: {
        license_count_increase: {
          title: "A domainhez már tartoznak aktív e-mail fiókok.",
          text_one: "Jelenleg {count} e-mail fiók tartozik ehhez a domainhez. Ahhoz, hogy használni tudja a Business Mail-t, legalább egy licencet kell rendelnie.",
          text_few: "Jelenleg {count} e-mail fiók tartozik a domainhez. A Business Mail használatához legalább ennyi licencet kell rendelnie.",
          text_other: "Jelenleg {count} e-mail fiók tartozik a domainhez. A Business Mail használatához legalább ennyi licencet kell rendelnie."
        },
        free_trial: {
          title: "Kezdje el 60 napos ingyenes próbaidőszakát még ma!",
          text: "Automatikusan aktiváltuk a 60 napos ingyenes teszt periódust a megrendelt Business Mail szolgáltatáshoz. Most már kipróbálhatja a Prémium licencet ingyenesen!"
        },
        free_trial_postfix: {
          title: "Kezdje el 60 napos ingyenes próbaidőszakát még ma!",
          text_one: "Automatikusan aktiválunk egy 60 napos próbaidőszakot minden olyan hosztolt postaládához, amelyet a Business Mail szolgáltatásunkba migrálunk, így Ön ingyenesen kipróbálhatja a prémium licencet. Kérjük, vegye figyelembe, hogy legalább annyi prémium licencet kell rendelnie, ahány postaládát szeretne migrálni (Önnek 1 postaládája van). <b>A migrálás hatással lehet a postaláda tartalmára (kapcsolatok/naptárak), ezért javasoljuk, hogy a szolgáltatás megrendelése előtt tekintse át a <a href='https://www.example.com' target='_blank'>Business Mailbe történő migrálás folyamatát</a>.</b>",
          text_few: "Automatikusan aktiválunk egy 60 napos próbaidőszakot minden olyan hosztolt postaládához, amelyet a Business Mail szolgáltatásunkba migrálunk, így Ön ingyenesen kipróbálhatja a prémium licencet. Kérjük, vegye figyelembe, hogy legalább annyi prémium licencet kell rendelnie, ahány postaládát szeretne migrálni (Önnek {count} postaládája van). <b>A migrálás hatással lehet a postaláda tartalmára (kapcsolatok/naptárak), ezért javasoljuk, hogy a szolgáltatás megrendelése előtt tekintse át a <a href='https://www.example.com' target='_blank'>Business Mailbe történő migrálás folyamatát</a></b>.",
          text_other: "Automatikusan aktiválunk egy 60 napos próbaidőszakot minden olyan hosztolt postaládához, amelyet a Business Mail szolgáltatásunkba migrálunk, így Ön ingyenesen kipróbálhatja a prémium licencet. Kérjük, vegye figyelembe, hogy legalább annyi prémium licencet kell rendelnie, ahány postaládát szeretne migrálni (Önnek {count} postaládája van). <b>A migrálás hatással lehet a postaláda tartalmára (kapcsolatok/naptárak), ezért javasoljuk, hogy a szolgáltatás megrendelése előtt tekintse át a <a href='https://www.example.com' target='_blank'>Business Mailbe történő migrálás folyamatát</a></b>."
        },
        free_trial_premium_licenses_notice: {
          title_one: "Legalább 1 prémium licencre van szüksége a Business Mailbe való migráláshoz",
          title_few: "Legalább {count} prémium licencre van szüksége a Business Mailbe való migráláshoz",
          title_other: "Legalább {count} prémium licencre van szüksége a Business Mailbe való migráláshoz",
          text: "Hogy megkönnyítsük a dolgát, automatikusan hozzáadtuk a megfelelő számú prémium licencet, hacsak nem tette meg azt az előző lépésben. <b>A migrálás hatással lehet a postafiók tartalmára (kapcsolatok/naptárak), ezért javasoljuk, hogy a szolgáltatás megrendelése előtt tekintse át a <a href='https://www.example.com' target='_blank'>Business Mailbe történő migrálás folyamatát.</a></b>"
        }
      }
    }
  },
  login_pages: {
    footer: {
      help: "Segítség",
      terms: "Feltételek",
      privacy: "Adatvédelem"
    },
    help: {
      title: "Segítségre van szükséged?",
      text: "Bármikor elérheted a <a href='{kb_url}' target='_blank'>tudásbázisunkat </a> vagy kapcsolatba léphetsz <a href='{support_url}' target='_blank'>ügyfélszolgálatunkkal</a>."
    }
  },
  message_service: {
    error: {
      axios: {
        title: "Network Error",
        text: "Unable to connect"
      },
      status_401: {
        text: "You don't have the required permissions."
      },
      status_403: {
        text: "Access denied."
      },
      status_404: {
        title: "Adat nem található",
        text: "Source not found."
      },
      status_407: {
        text: "Please login via the Legacy Active24 login page."
      },
      status_408: {
        text: "Connection timeout."
      },
      status_500: {
        text: "Uh oh, something went wrong. Please contact our support."
      },
      unexpected: {
        title: "Error",
        text: "Unexpected error"
      }
    }
  },
  ws_input: {
    invalid_phone_number: "Érvénytelen telefonszám",
    phone_missing: "A telefonszám megadása kötelező"
  },
  ws_google_autocomplete: {
    no_results: "A hely nem található, kérjük próbálja először kevésbé pontosan"
  }
};
const wsk_huHU = {
  wsk
};
export {
  wsk_huHU as default,
  wsk
};
//# sourceMappingURL=wsk.hu-HU.json.es.js.map
